var React = require("react");
var axios = require("axios");
var { error_message, upper } = require("@managers/helpers");

const SCIROOT_FARMING_TYPE_PATH = "farming_type";
let FARMING_TYPE_DATA = {};

export const farmingTypeList = () => Object.keys(FARMING_TYPE_DATA).sort();

export const farmingTypeData = () => {
  return new Promise(function (resolve, reject) {
    axios
      .get(SCIROOT_FARMING_TYPE_PATH, {})
      .then(function (res) {
        FARMING_TYPE_DATA = Object.fromEntries(
          Object.entries(res.data).map(([key, value]) => [key, upper(value)]),
        );
        resolve(FARMING_TYPE_DATA);
      })
      .catch(function (err) {
        console.log(error_message(err));
        reject(err);
      });
  });
};
